// extracted by css-extract-rspack-plugin
export default {"root":"root-aS9ZB1","pulse":"pulse-Nm054B","pivot":"pivot-CKAKVB"};